import axios from 'axios'
import Vue from 'vue'
import router from '../../router'
import tokenStorage from '@/plugins/tokenStorage'
import qs from 'qs'
import {Message} from 'element-ui'

let confirm = null
axios.defaults.paramsSerializer = (params) => qs.stringify(params, {arrayFormat: 'brackets'})
axios.interceptors.request.use(
  config => {
    const route = router.currentRoute
    const token = tokenStorage.getToken()
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    if (token && ((route.name === 'login' || route.name === 'adminLogin') || token.endsWith(route.query.token))) {
      config.headers.Authorization = token
    }
    // 兼容ie get请求直接拼接在接口后的参数
    config.url = encodeURI(config.url)
    return config
  },
  err => {
    return Promise.reject(err)
  })
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    return res
  },
  error => {
    // 先检查是否禁用拦截器，再检查错误请求的类型.
    if (!error.config.disableInterceptors) {
      if ([400, 401, 404, 500].includes(error.response.status)) {
        let message
        //  有类型并且无法正确转string。说明是文件流(ps：不确定这种这种判断是否能完全覆盖所有的文件流)
        if (error.response.data.type && JSON.stringify(error.response.data) === '{}') {
          let reader = new FileReader()
          reader.addEventListener('loadend', function () {
            Message({
              showClose: true,
              message: JSON.parse(reader.result).message || '系统异常，请稍候重试！',
              type: 'error'
            })
          })
          reader.readAsText(error.response.data, ['utf-8'])
        } else {
          if (error.response.status !== 500) {
            message = error.response.data.message
          }
          if (error.response.status === 401) {
            // 返回 401 清除token信息并跳转到登录页面
            if (!error.config.url.startsWith('/login')) {
              // 判断是否存在 回话过期窗口，如果存在则不弹框了
              if (!confirm) {
                confirm = tokenStorage.confirm().then(() => {
                  tokenStorage.removeToken()
                  router.replace({name: 'login'})
                  confirm = null
                }).catch(() => {
                  confirm = null
                })
              }
            }
          } else {
            Message({
              showClose: true,
              message: message || '系统异常，请稍候重试！',
              type: 'error'
            })
          }
        }
      }
    }

    // 返回 response 里的错误信息
    return Promise.reject(error)
  }
)

const vueAxios = {
  install () {
    Vue.$axios = axios
    Object.defineProperties(Vue.prototype, {
      $axios: {
        get () {
          return axios
        }
      }
    })
  }
}

export {vueAxios}
export default axios



// WEBPACK FOOTER //
// ./src/plugins/axios/index.js